import { render, staticRenderFns } from "./SucursalBreadcrumb.vue?vue&type=template&id=5d5a2704"
import script from "./SucursalBreadcrumb.vue?vue&type=script&lang=js"
export * from "./SucursalBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports